const numberOfNews = 3

export default numberOfNews